import script from "./TimetableSearchResult.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimetableSearchResult.vue?vue&type=script&setup=true&lang=ts"

import "./TimetableSearchResult.vue?vue&type=style&index=0&id=10572bee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10572bee"]])

export default __exports__